import clsx from "clsx";
import { cloneElement, createElement, HTMLAttributes, isValidElement } from "react";
import { PlainObject } from "@/interfaces/common";

type Props<P> = P & HTMLAttributes<any>;

export function useElement<P extends PlainObject = {}>(
  defaultProps: P,
  ...elements: JSX.Element[] | (() => JSX.Element)[] | any[]
) {
  return elements.map((element) => {
    if (!element) {
      return null;
    }

    let Element: any = element;

    if (!isValidElement(Element)) {
      Element = createElement(Element);
    }

    return (attributes: Props<P>) =>
      cloneElement<Props<P>>(Element, {
        ...defaultProps,
        ...attributes,
        ...(Element.props ?? {}),
        className: clsx(defaultProps.className, Element.props?.className),
      });
  });
}
